import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useAssignRole = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [assignRoleLoading, setAssignRoleLoading] = useState(false);

  const assignRoleRequest = ({ roleGuid, userGuid }, onSuccess) => {
    setAssignRoleLoading(true);
    axiosClient
      .put(`SettingAccount/User/Role/Assignment`, { roleGuid, userGuid })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`با موفقیت انجام شد`, {
            variant: 'success',
          });

          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setAssignRoleLoading(false));
  };

  return { assignRoleRequest, assignRoleLoading };
};

export default useAssignRole;
